var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanvaslms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.17 127.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e72429;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.45,63.47A18.4,18.4,0,0,0,2.31,45.23a73.13,73.13,0,0,0,0,36.47A18.38,18.38,0,0,0,18.45,63.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.13,57.7a5.77,5.77,0,1,0,5.77,5.77,5.77,5.77,0,0,0-5.77-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.72,63.47A18.38,18.38,0,0,0,124.86,81.7a73.13,73.13,0,0,0,0-36.47,18.4,18.4,0,0,0-16.14,18.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98,57.7a5.77,5.77,0,1,0,5.76,5.77A5.77,5.77,0,0,0,98,57.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.46,108.77A18.39,18.39,0,0,0,45.23,124.9a73.13,73.13,0,0,0,36.47,0,18.38,18.38,0,0,0-18.24-16.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.47,92.31a5.77,5.77,0,1,0,5.76,5.77,5.77,5.77,0,0,0-5.76-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.47,18.44A18.37,18.37,0,0,0,81.7,2.31a73.13,73.13,0,0,0-36.47,0A18.39,18.39,0,0,0,63.47,18.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.47,23.37a5.77,5.77,0,1,0,5.76,5.76,5.76,5.76,0,0,0-5.76-5.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.44,95.44a18.4,18.4,0,0,0-1.5,24.29,73,73,0,0,0,25.78-25.79,18.39,18.39,0,0,0-24.28,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.8,83.8a5.77,5.77,0,1,0,8.16,0,5.78,5.78,0,0,0-8.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.59,31.59a18.36,18.36,0,0,0,1.5-24.28A72.93,72.93,0,0,0,7.31,33.09a18.36,18.36,0,0,0,24.28-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.07,35.08a5.77,5.77,0,1,0,8.16,0,5.78,5.78,0,0,0-8.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.4,31.53A18.39,18.39,0,0,0,119.69,33,72.88,72.88,0,0,0,93.9,7.25a18.39,18.39,0,0,0,1.5,24.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.92,43.17a5.76,5.76,0,1,0-8.15,0,5.76,5.76,0,0,0,8.15,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.56,95.37a18.39,18.39,0,0,0-24.28-1.5,73,73,0,0,0,25.78,25.79,18.38,18.38,0,0,0-1.5-24.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,83.73a5.77,5.77,0,1,0,8.16,0,5.79,5.79,0,0,0-8.16,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvaslms);
export default __webpack_public_path__ + "static/media/canvaslms.9ae728edd30a7ada244d2dbf96b1eed1.svg";
export { ForwardRef as ReactComponent };